import type { ImageStyledProps } from './Image.styled';
import { ImageStyled } from './Image.styled';

export const Image = (props: ImageStyledProps) => {
  return <ImageStyled {...props} />;
};
